<template>
  <div>
    <header>
      <p v-on:click="backHistory" style="padding-left:1rem; " @click="">
        <img src="@/assets/img/back.png" alt="">
        <span style="color: #FFFFFF">附件简历</span>
      </p>
      <p style="color: #FFFFFF;padding-right:1rem" @click="send">发送</p>
    </header>
    <div style="padding:5rem 1rem">
      <ul class="">
        <li class=" ">
          <p v-if="fileList[0]">{{fileList[0].file.name}}</p>
          <a href="editperson.html" class="editbtn">预览</a>
        </li>
      </ul>
      <p style="color: #6e9bcf">选择你想上传的简历：</p>
      <p class="" ><van-uploader v-model="fileList" :after-read="onRead" accept="file"  upload-text="点击上传" multiple /></p>
    </div>

  </div>
</template>

<script>
  import axios from "axios"
  export default {
    name: 'message',
    data () {
      return {
        msg: '',
        color: "#FFFFFF",
//        color:"#000000",
        bool: true,
        fileList: [],
        file:{}
//          { url: 'http://zpapi.yuexinduo.com/upload/resume/953c7fe96da310d1919e92791acfd286.docx' },

      }
    },
    methods:{
      backHistory(){
         this.$router.go(-1)
      },
      onRead(file) {
        this.file=file
//        alert(1)
      },
       send(){
         if(!this.file.file) return this.$toast("请选择简历")
         var formData = new FormData();
         formData.append('file', this.file.file); //接口需要传的参数
         formData.append('user_id',localStorage.getItem("userid")); //接口需要传的参数
         axios({
             url:"http://zpapi.yuexinduo.com/index/resume/uploadResume",
             method: 'post',
//          data: {file:formData,userid:12},
             data:formData,
             processData: false,// 告诉axios不要去处理发送的数据(重要参数)
             contentType: false,// 告诉axios不要去设置Content-Type请求头
             msg:1}
         ).then((res)=>{
           if(res.status==200){
             this.$toast("发送成功")
           }
         })
       },
      clickIcon(event){
        this.bool=!this.bool
//        if(bool){
//          this.color="FFFFFF"
//        }
//        this.color="#FFFFFF"
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  scoped="">
  header{
    width: 100%;
    height: 65px;
    background-color: #6e9bcf;
    position: fixed;
    top:0 ;
    display: flex;
    justify-content: space-between;
    align-items: center;
    /*padding: 0 1rem;*/
    z-index: 100;
  }
  header img{
    width: 20px;
    height: 20px;
  }
  header p{
    display: flex;
  }
.manDiv{
width: 100%;
}
  .manDiv img{
    width: 30%;
  }
</style>



// WEBPACK FOOTER //
// src/components/sendResume.vue